'use strict';
const mmWidgets = require('./mm-widgets'),
	validAccountName = require('@mindmup/mindmup-common/src/valid-account-name');
mmWidgets.fn.addSubAccountWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			emailField = widget.find('[name="sub-account-email"]'),
			nameField = widget.find('[name="sub-account-name"]'),
			roleField = widget.find('[name="sub-account-role"]'),
			addSubAccountButton = widget.find('[data-mm-role~="add-sub-account-button"]'),
			validatedEmail = function (email) {
				if (!email || (email.length > 2 && email.indexOf('@') > 0)) {
					return email && email.trim();
				}
			},
			validatedAccountName = function (name) {
				return validAccountName(name) && name;
			},
			validateEmail = function (dontMark) {
				const email = validatedEmail(emailField.val()),
					controlBlock = emailField.parent();
				let valid = true;

				controlBlock.removeClass('error');
				if (!email) {
					valid = false;
				}
				if (!dontMark && !valid && emailField.val()) {
					controlBlock.addClass('error');
				}
				return valid && email;
			},
			validateAccountName = function (dontMark) {
				const name = validatedAccountName(nameField.val()),
					controlBlock = nameField.parent();
				let valid = true;

				controlBlock.removeClass('error');
				if (!name) {
					valid = false;
				}
				if (!dontMark && !valid && nameField.val()) {
					controlBlock.addClass('error');
				}
				return valid && name;
			},
			validate = function (dontMark) {
				const validEmail = validateEmail(dontMark),
					validName = validateAccountName(dontMark);
				if (validEmail && validName) {
					addSubAccountButton.removeClass('disabled');
					return validEmail;
				} else {
					addSubAccountButton.addClass('disabled');
				}
			},
			validateAndMark = function () {
				validate();
			};
		emailField.blur(validateAndMark).focus(validateAndMark).on('keyup', validateAndMark);
		nameField.blur(validateAndMark).focus(validateAndMark).on('keyup', validateAndMark);
		validate(true);
		subscriptionModel.addEventListener('goldAccountInfo', function () {
			emailField.val('');
			nameField.val('');
			emailField.val('');
			validate(true);
			widget.find('[data-mm-role="error"]').addClass('hidden');
		});
		addSubAccountButton.click(function () {
			const emailToLink = validate(),
				subAccountName = nameField.val(),
				subAccountRole = roleField.val(),
				subAccount = subAccountName && subAccountRole && {name: subAccountName, role: subAccountRole};
			if (!subAccount || !emailToLink) {
				return;
			}
			widget.find('[data-mm-role="error"]').addClass('hidden');
			subscriptionModel.addLinkedEmail(emailToLink, subAccount, {knownErrors: ['cognito-user-exists', 'email-exists']})
			.then(() => {
				nameField.val('');
				emailField.val('');
				widget.addClass('hidden');
			})
			.catch(function (reason) {
				const knownError = widget.find('[data-mm-role="error"][data-mm-reason="' +  reason + '"]');
				if (knownError.length) {
					knownError.removeClass('hidden');
				} else {
					widget.find('[data-mm-role="error"]:not([data-mm-reason])').removeClass('hidden');
				}
			});

		});

	});
};
